/* eslint-disable putout/multiple-properties-destructuring */
import { rootStore } from 'cv-react-core';

const getStyles = (isSelected, index) => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    const { listSelectedUnderlayColor, listUnderlayColor, colors } = theme;

    const { listAlternatingColors } = colors;
    let backgroundColor = listUnderlayColor;
    if (isSelected) {
        // If an item is selected used the selected underlay color.
        backgroundColor = listSelectedUnderlayColor;
    }
    else if (listAlternatingColors) {
        // If we have alternating colors, alternate via index number which matches native.
        const alternateColors = listAlternatingColors.split(',').map((m) => m.trim());
        if (alternateColors.length) {
            const colorIndex = index % alternateColors.length;
            backgroundColor = alternateColors[colorIndex];
        }
    }

    return {
        backgroundColor,
    };
};

export default getStyles;
